<div class="betslip-onboarding-content" *ngIf="message">
    <img class="onboarding-image" *ngIf="message.onboardingImageUrl" src="{{ message.onboardingImageUrl }}" />
    <div class="onboarding-header">{{ message.onboardingHeader }}</div>
    <div class="onboarding-body" [innerHTML]="message.onboardingBody"></div>
    <div class="onboarding-footer" [innerHTML]="message.onboardingFooter"></div>
</div>
